import React from 'react';
import { Stack } from '@mui/material';
import { PlannerLayout } from '../components/layout/PlannerLayout';
import { TripOverviewHero } from '../components/planner/TripOverviewHero';
import { PlannerInputPanel } from '../components/planner/PlannerInputPanel';
import { RecommendedDestinations } from '../components/planner/RecommendedDestinations';
import { usePlanner } from '../contexts/PlannerContext';
import { TripParameters } from '../types/chat';
import { initializeTripParameters } from '../utils/travel';

export const PlannerInputPage: React.FC = () => {
  const [tripParameters, setTripParameters] = React.useState<TripParameters>(initializeTripParameters());
  const { generatePlan } = usePlanner();

  const handleGenerate = (params: TripParameters) => {
    generatePlan(params, { confirmCreation: true });
  };

  return (
    <PlannerLayout
      transparentBackground
      sectionSx={{
        pt: { xs: 2, md: 2.5 },
        pb: { xs: 6, md: 4 },
      }}
      mainContentSx={{ mt: { xs: 1.5, sm: 2, md: 2 } }}
      overview={<TripOverviewHero summary={null} destinationInfo={null} dayCount={0} budget={undefined} />}
      mainContent={
        <Stack spacing={{ xs: 3, md: 3.5 }}>
          <PlannerInputPanel tripParameters={tripParameters} onTripParametersChange={setTripParameters} />
          <RecommendedDestinations onDestinationSelect={setTripParameters} onGenerate={handleGenerate} />
        </Stack>
      }
    />
  );
};
